import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "constants/routes";

interface Props {
	children: React.ReactNode;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
	const accessToken = localStorage.getItem("access_token");
	const isAuthenticated = !!accessToken;

	return isAuthenticated ? (
		<>{children}</>
	) : (
		<Navigate to={ROUTES.LOGIN} replace />
	);
};

export default PrivateRoute;
